import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { AssociateType } from "../../../components/filter/types/AssociateType";
import { fetchAssociateTourFilters } from "../thunks/fetchAssociateTourFilters";
import { IAssociateState } from "../types/IAssociateState";
import { selectMatchingItems } from "../utils/selectMatchingItems";
import { setMatchingItemFilter } from "../utils/setMatchingItemFilter";
import { updateSuggestedOnFetchComplete } from "./utils/updateSuggestedOnFetchComplete";

export const addFetchAssociateTourFilters = (builder: ActionReducerMapBuilder<IAssociateState>) => {
  builder.addCase(fetchAssociateTourFilters.pending, (state, action) => {
    state.loadingKeys = [...state.loadingKeys, `${action.meta.arg.operator}`];
  });
  builder.addCase(fetchAssociateTourFilters.rejected, (state, action) => {
    state.loadingKeys = state.loadingKeys.filter((itm) => itm !== `${action.meta.arg.operator}`);
  });
  builder.addCase(fetchAssociateTourFilters.fulfilled, (state, action) => {
    state.loadingKeys = state.loadingKeys.filter((itm) => itm !== `${action.meta.arg.operator}`);
    state.tourFilters[action.meta.arg.operator] = [...action.payload];

    if (action.meta.arg.noSuggestions !== true) {
      selectMatchingItems(
        state.operators.map((itm) => itm.id),
        state,
        state.tezTargets,
        action.meta.arg.operator,
        AssociateType.tours,
      );
      updateSuggestedOnFetchComplete(state, action.meta.arg.operator, action.payload);
    } else {
      const tourFilter = state.filterTour[10];
      const currentFilter = state.filterTour[action.meta.arg.operator];
      if (tourFilter && !currentFilter) {
        setMatchingItemFilter(10, tourFilter, state, "tour");
      }
    }
  });
};
